var TemplateLibraryLoadingView;

TemplateLibraryLoadingView = Marionette.ItemView.extend( {
	id: 'qazana-template-library-loading',

	template: '#tmpl-qazana-template-library-loading'
} );

module.exports = TemplateLibraryLoadingView;
